module.exports = __webpack_public_path__ + "static/media/tos.fa7a0a5c.txt";